function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from 'react';
import cardTypeInfo from 'credit-card-type';
import Icon from "./Icon";
import Input from "./Input";
import InputGroup from "./InputGroup";
import InputGroupAddon from "./InputGroupAddon";
import InputGroupText from "./InputGroupText";
var ICONS = {
  'american-express': 'cc-amex',
  'diners-club': 'cc-diners-club',
  'master-card': 'cc-mastercard',
  discover: 'cc-discover',
  jcb: 'cc-jcb',
  visa: 'cc-visa'
}; // runtime representation of card types for input validation

function typeToIconName() {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return ICONS[type.toLowerCase()] || 'credit-card';
}

function removeTypes(props) {
  delete props.types;
  return props;
}

function isAllowedCardType(x, allowedTypes) {
  // ok to cast here because we are inside the type card that validates the cast
  return allowedTypes.includes(x);
}

var defaultProps = _objectSpread(_objectSpread({}, removeTypes(Input.defaultProps)), {}, {
  className: '',
  types: Object.keys(ICONS),
  onChange: function onChange() {}
});

var CreditCardNumber = function CreditCardNumber(_ref) {
  var _ref$types = _ref.types,
      types = _ref$types === void 0 ? defaultProps.types : _ref$types,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? defaultProps.onChange : _ref$onChange,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? defaultProps.className : _ref$className,
      props = _objectWithoutProperties(_ref, ["types", "onChange", "className"]);

  var getType = function getType(value) {
    if (!value) {
      return undefined;
    }

    var typeInfo = cardTypeInfo(value); // Return type if only one CC pattern matches and if allowed types includes type

    if (typeInfo.length === 1 && isAllowedCardType(typeInfo[0].type, types)) {
      return typeInfo[0].type;
    }

    return undefined;
  };

  var onChangeHandler = function onChangeHandler(e) {
    var value = e.target.value;
    var type = getType(value);

    if (onChange) {
      onChange(value, type);
    }
  };
  /* eslint-disable  no-unused-vars */


  var type = props.type,
      value = props.value,
      inputProps = _objectWithoutProperties(props, ["type", "value"]);

  var ccType = getType(value);
  return /*#__PURE__*/React.createElement(InputGroup, {
    className: className
  }, /*#__PURE__*/React.createElement(Input, _extends({
    value: value || '',
    onChange: onChangeHandler
  }, inputProps)), /*#__PURE__*/React.createElement(InputGroupAddon, {
    addonType: "append"
  }, /*#__PURE__*/React.createElement(InputGroupText, {
    className: "p-0 px-2"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: typeToIconName(ccType),
    fixedWidth: true,
    size: "lg"
  }))));
};

CreditCardNumber.displayName = "CreditCardNumber";
CreditCardNumber.defaultProps = defaultProps;
CreditCardNumber.displayName = 'CreditCardNumber';
export default CreditCardNumber;